import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";

const AdmissionOverviewGraph = ({ data }) => {
  const maxValue = Math.max(
    ...data.reduce((acc, item) => {
      acc.push(
        item.admissionVacancy,
        item.reAdmissionVacancy,
        item.admission,
        item.reAdmission
      );
      return acc;
    }, [])
  );
  return (
    <div style={{ width: "100%", height: 350 }}>
      <ResponsiveContainer>
        <BarChart
          data={data}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid stroke="#CFCFCF" vertical={false} horizontal={true} />

          <XAxis dataKey="name" className="t-13 poppins weight-500" />
          <YAxis domain={[0, maxValue + 50]} tickCount={6} />

          <Tooltip
            content={({ payload }) => {
              return (
                <div className="flex-col back-white p-2 radius-6 g-05">
                  {payload.map((_data, index) => {
                    console.log(_data);

                    return (
                      <div className="flex-row">
                        <span
                          className="t-14 poppins"
                          style={{ color: _data.fill }}
                        >
                          {_data.dataKey.charAt(0).toUpperCase() +
                            _data.dataKey.slice(1, _data.dataKey.length)}
                          :{" "}
                        </span>
                        <span
                          className="t-14 poppins"
                          style={{ color: _data.fill }}
                        >
                          &nbsp;
                          {_data.payload[_data.dataKey]}
                        </span>
                      </div>
                    );
                  })}
                </div>
              );
            }}
          />

          <Bar
            style={{}}
            dataKey="admission"
            fill="#FFCC00"
            stackId={"a"}
            width={90}
          >
            <LabelList
              fill="white"
              dataKey="admission"
              position="inside"
              className="poppins t-13"
            />
          </Bar>
          <Bar
            dataKey="admissionVacancy"
            fill="#FFECA0"
            stackId={"a"}
            radius={[3, 3, 0, 0]}
          >
            <LabelList
              className="poppins t-13"
              fill="black"
              dataKey="admissionVacancy"
              position="inside"
            />
          </Bar>
          <Bar dataKey="reAdmission" fill="#869877" stackId={"b"} width={90}>
            <LabelList
              fill="white"
              dataKey="reAdmission"
              position="inside"
              className="poppins t-13"
            />
          </Bar>
          <Bar
            dataKey="reAdmissionVacancy"
            fill="#BDD0AE"
            stackId={"b"}
            radius={[3, 3, 0, 0]}
          >
            <LabelList
              className="poppins t-13"
              fill="black"
              dataKey="reAdmissionVacancy"
              position="inside"
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AdmissionOverviewGraph;
